import { a, useSpring } from '@react-spring/three';
import { THREE } from 'expo-three';
import { useEffect, useMemo, useState } from 'react';

import container from '~ioc/ioc';
import { ImageTextureCache } from '~stores/ImageTextureCache';

type Props = {
  imageUrl: string;
  size: number;
  bmpSize: number;
  showInstantly?: boolean;
  transparencyColor?: string;
  onImageLoad?: () => void;
  opacity?: number;
  useCache?: boolean;
};

export function ImageMaterial2({
  imageUrl,
  size,
  bmpSize,
  showInstantly,
  transparencyColor,
  onImageLoad,
  opacity = 1,
  useCache = false,
}: Props) {
  const [loaded, setLoaded] = useState(false);

  const colorMap = useMemo(() => {
    if (!imageUrl || !size) {
      return undefined;
    }

    // black magic on centering a bitmap on a card
    // and rendering its size up to the edges
    const bmpRatio = bmpSize / size;

    const texture = useCache
      ? container.get(ImageTextureCache)?.get(`${imageUrl}`, () => {
          setLoaded(true);
        })
      : new THREE.TextureLoader().load(imageUrl, () => {
          setLoaded(true);
        });

    // const texture = new THREE.TextureLoader().load(imageUrl, () => {
    //   setLoaded(true);
    // });
    //
    // const imageTextureCache = container.get(ImageTextureCache);
    // const texture = imageTextureCache.get(`${imageUrl}?no_cache`, () => {
    //   setLoaded(true);
    // });

    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.offset.set(0.5, 0.5);
    texture.repeat.set(bmpRatio / bmpSize, bmpRatio / bmpSize);

    return texture;
  }, [imageUrl, size]);

  useEffect(() => {
    if (loaded) {
      onImageLoad?.();
    }
  }, [loaded]);

  const getOpacity = () => {
    const internal = (() => {
      if (showInstantly) {
        return 1;
      }

      return loaded ? 1 : 0;
    })();

    return Math.min(internal, opacity);
  };

  const { opacityAnim } = useSpring({
    from: { opacityAnim: 0 },
    to: { opacityAnim: getOpacity() },
    config: { duration: 500 },
  });

  return (
    // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    <a.meshBasicMaterial
      map={colorMap}
      transparent
      opacity={opacityAnim}
      color={transparencyColor}
    />
  );
}
